package com.narbase.letsgo.web.utils.animation

import com.narbase.kunafa.core.components.View
import com.narbase.kunafa.core.css.keyframes
import com.narbase.kunafa.core.css.transform

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2022/07/14.
 */


fun View.errorShake() {
    element.style.animation = ""
    forceReflow(this)
    element.style.animation = "shake 0.82s cubic-bezier(.36,.07,.19,.97) both"
}

private fun forceReflow(view: View) {
    view.element.offsetWidth
}
